{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-10-11T11:20:27.889Z","source":"place-details"}